import {
  AtomMap,
  DEFAULT_MAP_CENTER,
  getActiveAssetIconFromSchemaMarkerId,
  getGoogleShapeCenter,
  getInactiveAssetIconFromSchemaMarkerId,
} from '@atom/map';
import { AssetDetail } from '@atom/types/asset';
import { GeoJSONGeometry, LocationGeometry } from '@atom/types/geojson';
import { EditTarget, LocationUpdatePayload } from '@atom/types/map';
import { PolicyAction } from '@atom/types/policy';
import { hasAccess } from '@atom/utilities/accessUtilities';
import { getColorFromColorId } from '@atom/utilities/colorUtilities';

const LOCATION_EDIT_ZOOM = 14;

type InventoryDetailMapProps = {
  onSave: (payload: LocationUpdatePayload) => void;
  asset: AssetDetail;
};

const InventoryDetailMap = ({ asset, onSave }: InventoryDetailMapProps) => {
  const location = asset?.location as GeoJSONGeometry;
  const center = getGoogleShapeCenter(location) ?? DEFAULT_MAP_CENTER;

  const canEdit = hasAccess(PolicyAction.UPDATE_LOCATION, asset.actions);

  const inactiveIcon = getInactiveAssetIconFromSchemaMarkerId(asset.markerId);
  const activeIcon = getActiveAssetIconFromSchemaMarkerId(asset.markerId);

  const target: EditTarget = {
    id: asset.id,
    name: asset.name,
    type: 'asset',
    address: asset.address,
    icon: <img src={inactiveIcon} alt="" />,
    activeIcon: <img src={activeIcon} alt="" />,
    color: getColorFromColorId(asset.markerId),
    location: location ?? null,
    canEdit,
  };

  const handleSave = (newLocation: LocationGeometry) => {
    onSave({ location: newLocation });
  };

  return (
    <AtomMap
      initialViewState={{ center, zoom: LOCATION_EDIT_ZOOM }}
      search="editable"
      editing={{
        targets: [target],
        onSave: handleSave,
      }}
    />
  );
};

export default InventoryDetailMap;
